export default __webpack_public_path__ + "static/media/janice_kee_body.aea9da21.png";